import * as React from "react"
import { useEffect } from "react"
import {batch} from "@preact/signals-react";

import { Box } from "@mui/material"

import { CommonFiltersMarketplaces } from "@components"
import { useAppDefaultFilters } from "@hooks"
import {COMMON_FILTER_KEYS, MARKETPLACES_ROUTES} from "@constants"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import { marketplacesOffersDetailsIsEmpty } from "./@signals"



export default function MarketplacesOffersDetailsFilters() {

    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(MARKETPLACES_ROUTES.OFFERS_DETAILS_ID, MARKETPLACES_ROUTES.ACCESS_KEY)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    return <Box data-tour="offers-details-filters">
    <CommonFiltersMarketplaces
        components={{
            buyBox: false, authorizedSeller: false, withShippingPrice: false,
            seller: true, favFilters: true, favFiltersOnlyLine: true
        }}
        compProps={{
            sku: { grid: { md: 3 } },
            skuGroup: { grid: { md: 2 } },
            seller: { grid: { md: 4} },
            favFilters: {
                grid: { md: 3 },
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
                    COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.SELLERS
                ],
                dashboardKey: MARKETPLACES_ROUTES.OFFERS_DETAILS_ID
            }
        }}
        onSubmit={() => {
            batch(() => {
                marketplacesOffersDetailsIsEmpty.value = false
                isSystemBusy.value = false
                isLoadingCommonFilters.value = true
            })
        }}
        userFilters={userFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}